var collectionGalleryList = null,
    collectionGallery = null,
    dynamicGallery = null,
    lightGalleryLoading = false,
    lightGalleryCallbacks = [];

var chairUtils = {
    // Find one element.
    query: function (selector, root) {
        return (root || document).querySelector(selector);
    },
    // Parse JSON with a fallback value.
    parseJSON: function (value, fallback) {
        try {
            return JSON.parse(value || "");
        } catch (error) {
            return fallback;
        }
    },
    // Parse a JSON script tag by id.
    getJSONScript: function (id, fallback) {
        var script = document.getElementById(id);
        return script ? chairUtils.parseJSON(script.textContent, fallback) : fallback;
    },
    // Safely set text content.
    setText: function (target, value) {
        if (target) target.textContent = value == null ? "" : value;
    },
    // Safely set form value.
    setValue: function (target, value) {
        if (target) target.value = value == null ? "" : value;
    },
    // Safely set display style.
    setDisplay: function (target, value) {
        if (target) target.style.display = value;
    },
    // Safely set disabled state.
    setDisabled: function (target, disabled) {
        if (target) target.disabled = disabled;
    },
    // Safely toggle a class.
    toggleClass: function (target, className, force) {
        if (target) target.classList.toggle(className, force);
    },
    // Format price through the theme helper.
    formatPrice: function (price) {
        return window.Boulies && window.Boulies.formatPrice ? window.Boulies.formatPrice(price) : price;
    },
    // Keep AJAX requests inside the active Shopify Market root.
    getRoute: function (endpoint) {
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
        return root.replace(/\/$/, "") + "/" + String(endpoint || "").replace(/^\//, "");
    },
};

var chairPageData = chairUtils.getJSONScript("chair-product-page-data", {
    colorImages: {},
    upholsteryImages: {},
});
chairPageData.colorImages = chairPageData.colorImages || {};
chairPageData.upholsteryImages = chairPageData.upholsteryImages || {};

/* ---  product functions --- */
var productInter = {
    isAddingToCart: false,
    warrantyAddonVariantId: "",
    // Keep the add-to-cart button in sync with the current request state.
    setAddToCartLoading: function (isLoading) {
        var button = document.getElementById("chair-product-add-to-cart");

        productInter.isAddingToCart = isLoading;
        if (!button) return;
        button.classList.toggle("is-adding", isLoading);
        var selectedVariant = document.querySelector('[data-chair-product-role="variant"]:checked');
        button.disabled = isLoading || !selectedVariant || selectedVariant.dataset.available != "true";
        productInter.syncStickyPurchaseBar();
    },
    // Build cart payload and submit the selected chair plus addons.
    addToCart: function (target) {
        if (!target || target.disabled || productInter.isAddingToCart) return false;
        var cartForm = document.getElementById("chair-product-form");
        if (!cartForm) return false;

        var chairData = new FormData(cartForm);
        // create main item data
        var itemsData = {
            items: [
                {
                    id: chairData.get("id"),
                    quantity: chairData.get("quantity"),
                    properties: {
                        warranty: chairData.get("properties[warranty]"),
                        accessories: chairData.get("properties[accessories]"),
                    },
                },
            ],
        };

        if (chairData.get("properties[Estimated shipping date]")) {
            itemsData.items[0].properties["Estimated shipping date"] = chairData.get("properties[Estimated shipping date]");
        }

        if (productInter.isWarrantyAddonSelected() && productInter.warrantyAddonVariantId) {
            itemsData.items.push({
                id: productInter.warrantyAddonVariantId,
                quantity: 1,
            });
        }

        if (!chairData.get("id")) return false;
        productInter.setAddToCartLoading(true);
        return ajaxcart.addItems(itemsData).always(function () {
            productInter.setAddToCartLoading(false);
        });
    },
    // Render pre-order batch progress for the selected variant.
    updatePreOrderInfo: function (batches, quantity) {
        var preOrderInfoWrap = document.getElementById("chair-product-preorder-waves");
        if (!preOrderInfoWrap) return;
        window.clearTimeout(productInter.preOrderProgressTimer);
        preOrderInfoWrap.textContent = "";
        if (!Array.isArray(batches) || batches.length == 0) {
            return;
        }

        batches.forEach(function (batch, index) {
            var batchWrap = document.createElement("div"),
                batchInfo = document.createElement("div"),
                batchNumber = document.createElement("span"),
                batchDate = document.createElement("span");

            batchWrap.className = "chair-product-preorder__wave" + (index == batches.length - 1 ? " is-current" : "");
            batchInfo.className = "chair-product-preorder__info";
            batchNumber.className = "chair-product-preorder__batch";
            batchNumber.textContent = index + 1;
            batchDate.className = "chair-product-preorder__date";
            batchDate.textContent = batch.estimatedShippingDate;
            batchInfo.appendChild(batchNumber);
            batchInfo.appendChild(batchDate);
            batchWrap.appendChild(batchInfo);

            if (index == batches.length - 1) {
                var progressWrap = document.createElement("div"),
                    progressValue = document.createElement("div");
                progressWrap.className = "chair-product-preorder__progress";
                progressValue.className = "chair-product-preorder__progress-value";
                progressValue.id = "chair-product-preorder-progress";
                progressWrap.appendChild(progressValue);
                batchWrap.appendChild(progressWrap);
            }
            preOrderInfoWrap.appendChild(batchWrap);
        });

        var totalNumber = parseInt(batches[batches.length - 1].batchQuantity, 10),
            selectedQuantity = parseInt(quantity, 10),
            progressPercentage = totalNumber > 0 && Number.isFinite(selectedQuantity) ? Math.round(((totalNumber - selectedQuantity) / totalNumber) * 100) : 0;
        progressPercentage = Math.max(0, Math.min(100, progressPercentage));
        var orderStatus = progressPercentage + "%";
        productInter.preOrderProgressTimer = window.setTimeout(function () {
            var progress = document.getElementById("chair-product-preorder-progress");
            if (!progress) return;
            progress.textContent = orderStatus;
            progress.style.width = orderStatus;
        }, 1000);
    },
    preOrderProgressTimer: null,
    saleCodeScrollTimer: null,
    saleCodeScrollDelay: null,
    // Auto-scroll long sale code text when it overflows.
    initSaleCodeAutoScroll: function () {
        var saleCodeInfo = document.querySelector(".chair-product-promotion__message");
        if (!saleCodeInfo) return;

        clearInterval(productInter.saleCodeScrollTimer);
        clearTimeout(productInter.saleCodeScrollDelay);
        productInter.saleCodeScrollTimer = null;
        productInter.saleCodeScrollDelay = null;
        saleCodeInfo.scrollLeft = 0;
        saleCodeInfo.classList.remove("chair-product-promotion__message--scrolling");

        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        productInter.saleCodeScrollDelay = setTimeout(function () {
            var maxScrollLeft = saleCodeInfo.scrollWidth - saleCodeInfo.clientWidth;
            if (maxScrollLeft <= 1) return;

            var direction = 1;
            var pauseTicks = 18;
            saleCodeInfo.classList.add("chair-product-promotion__message--scrolling");
            productInter.saleCodeScrollTimer = setInterval(function () {
                if (pauseTicks > 0) {
                    pauseTicks--;
                    return;
                }

                saleCodeInfo.scrollLeft += direction;

                if (saleCodeInfo.scrollLeft >= maxScrollLeft) {
                    direction = -1;
                    pauseTicks = 18;
                } else if (saleCodeInfo.scrollLeft <= 0) {
                    direction = 1;
                    pauseTicks = 18;
                }
            }, 40);
        }, 150);
    },
    galleryImagesByKey: null,
    currentGalleryImageKey: null,
    galleryUpdateRequestId: 0,
    galleryLayoutFrame: null,
    galleryLayoutMode: null,
    galleryResizeObserver: null,
    galleryObservedWidth: 0,
    variantGalleryVideos: [],
    activeGalleryVideoIndex: 0,
    // Escape text before interpolating into generated HTML.
    escapeHtml: function (value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    },
    // Group gallery images and Shopify-hosted videos by variant key.
    getGalleryImagesByKey: function () {
        if (productInter.galleryImagesByKey) return productInter.galleryImagesByKey;

        var galleryData = document.getElementById("chair-product-gallery-data"),
            imageList = [];

        productInter.galleryImagesByKey = {};
        if (!galleryData) return productInter.galleryImagesByKey;

        imageList = chairUtils.parseJSON(galleryData.textContent || "[]", []);

        imageList.forEach(function (media) {
            if (!media.imageKey) return;
            if (!productInter.galleryImagesByKey[media.imageKey]) {
                productInter.galleryImagesByKey[media.imageKey] = [];
            }
            productInter.galleryImagesByKey[media.imageKey].push(media);
        });

        return productInter.galleryImagesByKey;
    },
    // Return image slides only; variant videos use the separate video panel.
    getVariantGalleryImages: function (imageKey) {
        return (productInter.getGalleryImagesByKey()[imageKey] || []).filter(function (media) {
            return media.type != "video" && !!(media.src || media.main);
        });
    },
    // Return all usable Shopify-hosted videos for one variant key.
    getVariantGalleryVideos: function (imageKey) {
        var mediaList = productInter.getGalleryImagesByKey()[imageKey] || [];
        return mediaList.filter(function (media) {
            return media.type == "video" && Array.isArray(media.sources) && media.sources.some(function (source) {
                return source && source.src;
            });
        });
    },
    // Keep thumbnail count aligned with available gallery images.
    getGalleryListSlidesToShow: function (imageCount) {
        if (imageCount <= 1) return 1;
        return Math.min(4, imageCount);
    },
    // Build thumbnail settings from the current image count before Slick starts.
    getGalleryListSlickOptions: function (imageCount) {
        var slidesToShow = productInter.getGalleryListSlidesToShow(imageCount),
            mobileSlidesToShow = Math.min(3, Math.max(1, imageCount));

        return {
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            asNavFor: "#chair-product-gallery-main",
            dots: false,
            arrows: true,
            prevArrow: '<div class="sideList-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 15 7-7 7 7" fill="none" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
            nextArrow: '<div class="sideList-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 15 7-7 7 7" fill="none" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
            centerMode: false,
            centerPadding: "0",
            infinite: true,
            variableWidth: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true,
            speed: 500,
            responsive: [
                {
                    breakpoint: 1329,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        variableWidth: false,
                    },
                },
                {
                    breakpoint: 961,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: mobileSlidesToShow,
                        centerMode: true,
                        variableWidth: false,
                    },
                },
                {
                    breakpoint: 651,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: mobileSlidesToShow,
                        centerMode: true,
                        variableWidth: false,
                    },
                },
            ],
        };
    },
    // Build the main gallery settings before Slick starts.
    getGalleryMainSlickOptions: function () {
        return {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: "#chair-product-gallery-track",
            speed: 500,
        };
    },
    // Return Slick's slide count without assuming the slider is initialized.
    getGallerySlideCount: function (gallery) {
        if (!gallery || !gallery.length || !gallery.hasClass("slick-initialized")) return 0;
        return gallery.slick("getSlick").slideCount || 0;
    },
    // Remove Slick wrappers before replacing all slides in one DOM update.
    destroyProductGallerySliders: function () {
        productInter.pauseProductGalleryVideos();
        if (collectionGallery && collectionGallery.hasClass("slick-initialized")) {
            collectionGallery.slick("unslick");
        }
        if (collectionGalleryList && collectionGalleryList.hasClass("slick-initialized")) {
            collectionGalleryList.slick("unslick");
        }
    },
    // Initialize both synchronized sliders only after all slide markup exists.
    initializeProductGallerySliders: function (imageCount) {
        if (!imageCount || !collectionGalleryList.length || !collectionGallery.length) return;
        collectionGallery.off(".chairProductVideo").on("beforeChange.chairProductVideo", function () {
            productInter.pauseProductGalleryVideos();
        });
        collectionGalleryList.slick(productInter.getGalleryListSlickOptions(imageCount));
        collectionGallery.slick(productInter.getGalleryMainSlickOptions());
        productInter.galleryLayoutMode = productInter.getGalleryLayoutMode();
    },
    // Stop media that is leaving the active slide or being removed for another variant.
    pauseProductGalleryVideos: function () {
        var galleryMain = document.getElementById("chair-product-gallery-main");
        if (galleryMain) {
            galleryMain.querySelectorAll("video").forEach(function (video) {
                if (!video.paused) video.pause();
            });
        }
        var galleryVideo = document.getElementById("chair-product-gallery-video");
        if (galleryVideo && !galleryVideo.paused) galleryVideo.pause();
    },
    // Load one video from the current variant video group into the shared player.
    loadProductGalleryVideo: function (videoIndex) {
        var galleryVideo = document.getElementById("chair-product-gallery-video"),
            media = productInter.variantGalleryVideos[videoIndex];

        if (!galleryVideo || !media) return false;

        if (!galleryVideo.paused) galleryVideo.pause();
        galleryVideo.removeAttribute("poster");
        galleryVideo.replaceChildren();
        if (media.poster) galleryVideo.poster = media.poster;
        media.sources.filter(function (source) {
            return source && source.src;
        }).forEach(function (source) {
            var sourceNode = document.createElement("source");
            sourceNode.src = source.src;
            sourceNode.type = source.type || "video/mp4";
            galleryVideo.appendChild(sourceNode);
        });
        galleryVideo.load();
        productInter.activeGalleryVideoIndex = videoIndex;

        document.querySelectorAll("[data-gallery-video-index]").forEach(function (button) {
            var isCurrent = parseInt(button.dataset.galleryVideoIndex, 10) == videoIndex;
            button.classList.toggle("is-current", isCurrent);
            button.setAttribute("aria-current", isCurrent ? "true" : "false");
        });
        return true;
    },
    // Match the same breakpoint used by CSS for the Watch Video dropdown.
    isCompactProductGalleryVideoMode: function () {
        return window.matchMedia
            ? window.matchMedia("(max-width: 1328px)").matches
            : window.innerWidth <= 1328;
    },
    // Close the compact Watch Video dropdown and keep its ARIA state synchronized.
    closeProductGalleryVideoList: function (shouldRestoreFocus) {
        var galleryBox = document.getElementById("chair-product-gallery"),
            mobileTrigger = document.querySelector('[data-chair-product-action="toggle-gallery-video"]');

        if (!galleryBox || !galleryBox.classList.contains("is-video-list-open")) return;
        galleryBox.classList.remove("is-video-list-open");
        productInter.syncProductGalleryVideoMode();
        if (shouldRestoreFocus && mobileTrigger) mobileTrigger.focus();
    },
    // Bring the shared player into view after a compact-layout video is selected.
    scrollToProductGalleryVideo: function () {
        var galleryBox = document.getElementById("chair-product-gallery"),
            reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (!galleryBox) return;
        var scrollToGallery = function () {
            try {
                galleryBox.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
            } catch (error) {
                galleryBox.scrollIntoView(true);
            }
        };
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(scrollToGallery);
        } else {
            window.setTimeout(scrollToGallery, 0);
        }
    },
    // Show or hide the shared video player without changing the image Slick state.
    setProductGalleryVideoActive: function (isActive, shouldPlay, videoIndex) {
        var galleryBox = document.getElementById("chair-product-gallery"),
            videoPanel = document.getElementById("chair-product-gallery-video-panel"),
            mobileTrigger = document.querySelector('[data-chair-product-action="toggle-gallery-video"]'),
            galleryVideo = document.getElementById("chair-product-gallery-video");

        if (!galleryBox || !videoPanel || !galleryVideo || !galleryBox.classList.contains("has-variant-video")) return;

        if (isActive && typeof videoIndex == "number") productInter.loadProductGalleryVideo(videoIndex);
        galleryBox.classList.toggle("is-video-active", !!isActive);
        if (mobileTrigger) {
            var triggerExpanded = productInter.isCompactProductGalleryVideoMode()
                ? galleryBox.classList.contains("is-video-list-open")
                : !!isActive;
            mobileTrigger.setAttribute("aria-expanded", triggerExpanded ? "true" : "false");
        }
        productInter.syncProductGalleryVideoMode();

        if (isActive && shouldPlay) {
            var playPromise = galleryVideo.play();
            if (playPromise && typeof playPromise.catch == "function") playPromise.catch(function () {});
        } else if (!isActive && !galleryVideo.paused) {
            galleryVideo.pause();
        }
    },
    // Keep the video panel state synchronized across the desktop rail and responsive dropdown.
    syncProductGalleryVideoMode: function () {
        var galleryBox = document.getElementById("chair-product-gallery"),
            videoPanel = document.getElementById("chair-product-gallery-video-panel"),
            galleryVideo = document.getElementById("chair-product-gallery-video"),
            mobileTrigger = document.querySelector('[data-chair-product-action="toggle-gallery-video"]'),
            compactVideoList = document.getElementById("chair-product-gallery-video-sp-menu"),
            isCompactMode = productInter.isCompactProductGalleryVideoMode(),
            isActive = galleryBox && galleryBox.classList.contains("is-video-active"),
            isListOpen = galleryBox && galleryBox.classList.contains("is-video-list-open");

        if (!galleryBox || !videoPanel || !galleryBox.classList.contains("has-variant-video")) return;
        if (!isCompactMode && isListOpen) {
            galleryBox.classList.remove("is-video-list-open");
            isListOpen = false;
        }
        videoPanel.setAttribute("aria-hidden", isActive ? "false" : "true");
        if (compactVideoList) compactVideoList.setAttribute("aria-hidden", isCompactMode && isListOpen ? "false" : "true");
        if (mobileTrigger) {
            mobileTrigger.setAttribute("aria-controls", isCompactMode && compactVideoList ? compactVideoList.id : videoPanel.id);
            mobileTrigger.setAttribute("aria-expanded", (isCompactMode ? isListOpen : isActive) ? "true" : "false");
        }
        if (!isActive && galleryVideo && !galleryVideo.paused) galleryVideo.pause();
    },
    // Rebuild both video thumbnail groups when the selected variant changes.
    updateProductGalleryVideo: function (imageKey) {
        var galleryBox = document.getElementById("chair-product-gallery"),
            videoPanel = document.getElementById("chair-product-gallery-video-panel"),
            galleryVideo = document.getElementById("chair-product-gallery-video"),
            mobileTrigger = document.querySelector('[data-chair-product-action="toggle-gallery-video"]'),
            videoLists = document.querySelectorAll('[data-chair-product-role="gallery-video-list"]'),
            mediaList = productInter.getVariantGalleryVideos(imageKey),
            hadLoadedVideo;

        if (!galleryBox || !videoPanel || !galleryVideo || !mobileTrigger || !videoLists.length) return;

        hadLoadedVideo = !!(galleryVideo.currentSrc || galleryVideo.getAttribute("src") || galleryVideo.querySelector("source"));
        productInter.pauseProductGalleryVideos();
        galleryBox.classList.remove("has-variant-video", "is-video-active", "is-video-list-open");
        videoPanel.setAttribute("aria-hidden", "true");
        mobileTrigger.setAttribute("aria-expanded", "false");
        galleryVideo.removeAttribute("poster");
        galleryVideo.removeAttribute("src");
        galleryVideo.replaceChildren();
        if (hadLoadedVideo) galleryVideo.load();
        videoLists.forEach(function (videoList) {
            videoList.replaceChildren();
        });
        productInter.variantGalleryVideos = mediaList;
        productInter.activeGalleryVideoIndex = 0;

        if (!mediaList.length) return;

        mediaList.forEach(function (media, index) {
            var button = document.createElement("button"),
                mediaBox = document.createElement("span"),
                playIcon = document.createElement("span"),
                actionIcon = document.createElement("span"),
                triggerIcon = mobileTrigger.querySelector(".chair-product-gallery__video-sp-label svg");

            button.type = "button";
            button.className = "chair-product-gallery__video-item";
            button.dataset.chairProductAction = "open-gallery-video";
            button.dataset.galleryVideoIndex = index;
            button.setAttribute("aria-label", "Play product video " + (index + 1));
            button.classList.toggle("is-current", index == 0);
            button.setAttribute("aria-current", index == 0 ? "true" : "false");
            mediaBox.className = "chair-product-gallery__video-item-media";
            if (media.thumb || media.poster) {
                var image = document.createElement("img");
                image.src = media.thumb || media.poster;
                image.alt = "";
                image.width = 72;
                image.height = 41;
                image.loading = "lazy";
                image.decoding = "async";
                mediaBox.appendChild(image);
            }
            playIcon.className = "chair-product-gallery__video-play";
            playIcon.setAttribute("aria-hidden", "true");
            playIcon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#000" fill-opacity=".58"/><path d="m10 8 6 4-6 4V8Z" fill="#fff"/></svg>';
            mediaBox.appendChild(playIcon);
            button.appendChild(mediaBox);
            actionIcon.className = "chair-product-gallery__video-item-action";
            actionIcon.setAttribute("aria-hidden", "true");
            if (triggerIcon) actionIcon.appendChild(triggerIcon.cloneNode(true));
            button.appendChild(actionIcon);
            videoLists.forEach(function (videoList, listIndex) {
                videoList.appendChild(listIndex == 0 ? button : button.cloneNode(true));
            });
        });

        galleryBox.classList.add("has-variant-video");
        productInter.syncProductGalleryVideoMode();
    },
    // Bind the Watch Video dropdown, playback, and close controls once.
    initProductGalleryVideoInteractions: function () {
        var galleryBox = document.getElementById("chair-product-gallery");
        if (!galleryBox || galleryBox.dataset.videoReady == "true") return;
        galleryBox.dataset.videoReady = "true";

        galleryBox.addEventListener("click", function (event) {
            var videoButton = event.target.closest('[data-chair-product-action="open-gallery-video"]'),
                mobileTrigger = event.target.closest('[data-chair-product-action="toggle-gallery-video"]'),
                closeButton = event.target.closest('[data-chair-product-action="close-gallery-video"]');
            if (videoButton) {
                var isCompactMode = productInter.isCompactProductGalleryVideoMode();
                if (isCompactMode) galleryBox.classList.remove("is-video-list-open");
                productInter.setProductGalleryVideoActive(true, true, parseInt(videoButton.dataset.galleryVideoIndex, 10) || 0);
                if (isCompactMode) productInter.scrollToProductGalleryVideo();
            } else if (mobileTrigger) {
                if (productInter.isCompactProductGalleryVideoMode()) {
                    var isListOpen = galleryBox.classList.toggle("is-video-list-open");
                    mobileTrigger.setAttribute("aria-expanded", isListOpen ? "true" : "false");
                    productInter.syncProductGalleryVideoMode();
                } else {
                    var isActive = galleryBox.classList.contains("is-video-active");
                    productInter.setProductGalleryVideoActive(!isActive, !isActive, productInter.activeGalleryVideoIndex);
                }
            } else if (closeButton) {
                productInter.setProductGalleryVideoActive(false, false);
            }
        });

        document.addEventListener("click", function (event) {
            if (event.target.closest && event.target.closest(".chair-product-gallery__video-sp-dropdown")) return;
            productInter.closeProductGalleryVideoList(false);
        });

        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape") return;
            productInter.closeProductGalleryVideoList(true);
        });

        if (collectionGalleryList && collectionGalleryList.length) {
            collectionGalleryList.off("click.chairProductVideoState").on("click.chairProductVideoState", ".slick-slide", function () {
                productInter.setProductGalleryVideoActive(false, false);
            });
        }
    },
    // Group viewport widths into the same four modes used by CSS and Slick.
    getGalleryLayoutMode: function () {
        if (window.matchMedia) {
            if (window.matchMedia("(max-width: 650px)").matches) return "mobile";
            if (window.matchMedia("(max-width: 960px)").matches) return "compact";
            if (window.matchMedia("(max-width: 1328px)").matches) return "horizontal";
            return "vertical";
        }
        if (window.innerWidth <= 650) return "mobile";
        if (window.innerWidth <= 960) return "compact";
        if (window.innerWidth <= 1328) return "horizontal";
        return "vertical";
    },
    // Refresh Slick after breakpoint, orientation, bfcache, or container-size changes.
    scheduleProductGalleryLayout: function (forceResponsive) {
        var requestFrame = function (callback) {
            return window.requestAnimationFrame ? window.requestAnimationFrame(callback) : window.setTimeout(callback, 16);
        };

        if (productInter.galleryLayoutFrame) {
            if (window.cancelAnimationFrame) {
                window.cancelAnimationFrame(productInter.galleryLayoutFrame);
            } else {
                window.clearTimeout(productInter.galleryLayoutFrame);
            }
        }
        productInter.galleryLayoutFrame = requestFrame(function () {
            var nextMode = productInter.getGalleryLayoutMode(),
                shouldCheckResponsive = forceResponsive || nextMode != productInter.galleryLayoutMode;

            productInter.galleryLayoutFrame = null;
            [collectionGalleryList, collectionGallery].forEach(function (gallery) {
                if (!gallery || !gallery.length || !gallery.hasClass("slick-initialized")) return;
                var slickInstance = gallery.slick("getSlick");
                if (shouldCheckResponsive && slickInstance && typeof slickInstance.checkResponsive == "function") {
                    slickInstance.checkResponsive(false, true);
                }
                gallery.slick("setPosition");
            });
            productInter.galleryLayoutMode = nextMode;
        });
    },
    // Observe the gallery container because its width can change without a viewport resize.
    initProductGalleryResizeObserver: function () {
        var galleryBox = document.getElementById("chair-product-gallery");
        if (!galleryBox || !window.ResizeObserver || productInter.galleryResizeObserver) return;

        productInter.galleryResizeObserver = new window.ResizeObserver(function (entries) {
            var width = entries.length && entries[0].contentRect ? Math.round(entries[0].contentRect.width) : 0;
            if (!width || width == productInter.galleryObservedWidth) return;
            productInter.galleryObservedWidth = width;
            productInter.scheduleProductGalleryLayout(false);
        });
        productInter.galleryResizeObserver.observe(galleryBox);
    },
    // Load one external script without blocking the initial product-page render.
    loadGalleryScript: function (src, callback) {
        var script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = function () {
            callback(true);
        };
        script.onerror = function () {
            if (script.parentNode) script.parentNode.removeChild(script);
            callback(false);
        };
        document.head.appendChild(script);
    },
    // Notify all gallery clicks waiting for the optional LightGallery files.
    flushLightGalleryCallbacks: function (isReady) {
        var callbacks = lightGalleryCallbacks.slice();
        lightGalleryCallbacks = [];
        lightGalleryLoading = false;
        callbacks.forEach(function (callback) {
            callback(isReady);
        });
    },
    // Load LightGallery and its zoom plugin only when the visitor opens an image.
    ensureLightGallery: function (callback) {
        var lightGallerySrc = "https://cdn.jsdelivr.net/npm/lightgallery@2.4.0/lightgallery.umd.min.js",
            zoomPluginSrc = "https://cdn.jsdelivr.net/npm/lightgallery@2.4.0/plugins/zoom/lg-zoom.min.js";

        if (window.lightGallery && window.lgZoom) {
            callback(true);
            return;
        }

        lightGalleryCallbacks.push(callback);
        if (lightGalleryLoading) return;
        lightGalleryLoading = true;

        var loadZoomPlugin = function () {
            if (window.lgZoom) {
                productInter.flushLightGalleryCallbacks(true);
                return;
            }
            productInter.loadGalleryScript(zoomPluginSrc, function (loaded) {
                productInter.flushLightGalleryCallbacks(loaded && !!window.lgZoom);
            });
        };

        if (window.lightGallery) {
            loadZoomPlugin();
            return;
        }

        productInter.loadGalleryScript(lightGallerySrc, function (loaded) {
            if (!loaded || !window.lightGallery) {
                productInter.flushLightGalleryCallbacks(false);
                return;
            }
            loadZoomPlugin();
        });
    },
    // Reuse one dynamic LightGallery instance for product and description images.
    openDynamicGallery: function (items) {
        if (!items || !items.length) return;
        productInter.ensureLightGallery(function (isReady) {
            if (!isReady) {
                window.location.href = items[0].src;
                return;
            }
            if (!dynamicGallery) {
                // LightGallery 2.4 may finish a zoom callback after a rapid close
                // has removed the slide. Keep the guard local to this gallery.
                class ChairGalleryZoom extends window.lgZoom {
                    setZoomEssentials() {
                        if (!this.core.getSlideItem(this.core.index).find(".lg-image").first().get()) return;
                        super.setZoomEssentials();
                    }
                }
                dynamicGallery = window.lightGallery(document.body, {
                    licenseKey: "DA7E83CA-6E474542-97592C9F-8A8DFF9D",
                    dynamic: true,
                    controls: false,
                    download: false,
                    showCloseIcon: true,
                    mobileSettings: {
                        controls: false,
                        download: false,
                        showCloseIcon: true,
                    },
                    plugins: [ChairGalleryZoom],
                    dynamicEl: [],
                });
            }
            dynamicGallery.refresh(items);
            dynamicGallery.openGallery();
        });
    },
    // Toggle the gallery loading visual state.
    setProductGalleryLoading: function (isLoading) {
        var galleryBox = document.getElementById("chair-product-gallery");
        if (!galleryBox) return;
        galleryBox.classList.toggle("is-loading", isLoading);
    },
    // Preload the first image or video poster before swapping an existing gallery.
    preloadProductGalleryFirstImage: function (galleryImages, callback) {
        var firstImage = galleryImages.length ? galleryImages[0] : null,
            preloadSrc = firstImage && firstImage.type == "video"
                ? firstImage.poster || ""
                : firstImage && window.devicePixelRatio > 1 && firstImage.main2x
                    ? firstImage.main2x
                    : firstImage
                        ? firstImage.main || firstImage.src
                        : "",
            preloadImage,
            preloadTimer,
            isDone = false,
            done = function () {
                if (isDone) return;
                isDone = true;
                clearTimeout(preloadTimer);
                callback();
            };

        if (!preloadSrc) {
            callback();
            return;
        }

        preloadImage = new Image();
        preloadTimer = setTimeout(done, 900);
        preloadImage.onload = done;
        preloadImage.onerror = done;
        preloadImage.src = preloadSrc;

        if (preloadImage.complete) done();
    },
    // Replace Slick slides with the selected variant image gallery.
    renderProductGallery: function (galleryImages, imageKey) {
        var mainSlides = [],
            thumbSlides = [];

        galleryImages.forEach(function (media, index) {
            var altText = productInter.escapeHtml(media.alt || "");

            var originalImage = media.src || media.main || "",
                mainImage = media.main || Boulies.imageResize(originalImage, 640),
                main2xImage = media.main2x || Boulies.imageResize(originalImage, 1280),
                thumbImage = media.thumb || Boulies.imageResize(originalImage, 180),
                imageWidth = media.width || 1280,
                imageHeight = media.height || 1280,
                mainLoading = index == 0 ? "eager" : "lazy",
                mainPriority = index == 0 ? ' fetchpriority="high"' : "";

            mainSlides.push('<a class="pswp_image" href="' + originalImage + '" data-lg-size="' + imageWidth + "-" + imageHeight + '" target="_blank"><img class="chair-product-gallery__image" src="' + mainImage + '" srcset="' + mainImage + " 1x, " + main2xImage + ' 2x" sizes="(max-width: 650px) 100vw, 640px" alt="' + altText + '" width="640" height="640" loading="' + mainLoading + '" decoding="async"' + mainPriority + "></a>");
            thumbSlides.push('<div><img src="' + thumbImage + '" alt="' + altText + '" width="60" height="60" loading="lazy" decoding="async"></div>');
        });

        productInter.destroyProductGallerySliders();
        collectionGallery.html(mainSlides.join(""));
        collectionGalleryList.html(thumbSlides.join(""));
        productInter.initializeProductGallerySliders(galleryImages.length);

        if (galleryImages.length > 0) {
            collectionGallery.slick("slickGoTo", 0, true);
            collectionGalleryList.slick("slickGoTo", 0, true);
            productInter.scheduleProductGalleryLayout(false);
        }
        productInter.currentGalleryImageKey = imageKey;
    },
    // Refresh the gallery for the selected variant.
    updateProductGallery: function (imageKey) {
        var galleryImages = productInter.getVariantGalleryImages(imageKey),
            mainSlideCount = productInter.getGallerySlideCount(collectionGallery),
            hasCurrentGallery = mainSlideCount > 0,
            requestId;

        productInter.updateProductGalleryVideo(imageKey);

        productInter.galleryUpdateRequestId++;
        requestId = productInter.galleryUpdateRequestId;

        if (productInter.currentGalleryImageKey == imageKey && mainSlideCount > 0) {
            productInter.setProductGalleryLoading(false);
            return;
        }

        if (!hasCurrentGallery) {
            productInter.renderProductGallery(galleryImages, imageKey);
            return;
        }

        productInter.setProductGalleryLoading(true);
        productInter.preloadProductGalleryFirstImage(galleryImages, function () {
            if (requestId != productInter.galleryUpdateRequestId) return;

            productInter.renderProductGallery(galleryImages, imageKey);
            var finishLoading = function () {
                if (requestId == productInter.galleryUpdateRequestId) {
                    productInter.setProductGalleryLoading(false);
                }
            };
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(finishLoading);
            } else {
                window.setTimeout(finishLoading, 16);
            }
        });
    },
    // Format Shopify's ISO date as the customer-facing US date.
    formatPreorderDate: function (value) {
        var match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return value || "";

        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return months[parseInt(match[2], 10) - 1] + " " + parseInt(match[3], 10) + ", " + match[1];
    },
    // Read the typed metaobject list rendered for the selected variant.
    getVariantPreorderBatches: function (variantInput) {
        if (!variantInput || !variantInput.dataset) return [];
        var template = document.getElementById(variantInput.dataset.preorderBatchesId);
        if (!template) return [];
        var root = template.content || template;
        return Array.prototype.map.call(root.querySelectorAll("[data-preorder-batch]"), function (batch) {
            return {
                estimatedShippingDate: productInter.formatPreorderDate(batch.dataset.estimatedShippingDate),
                batchQuantity: parseInt(batch.dataset.batchQuantity, 10) || 0,
            };
        });
    },
    // A non-empty batch list enables pre-order for an available variant.
    isPreOrderVariant: function (batches) {
        return Array.isArray(batches) && batches.length > 0;
    },
    // Read URL params through the theme helper without assuming it always exists.
    getUrlParams: function () {
        if (!window.Boulies || !window.Boulies.getUrlkey) return {};
        return window.Boulies.getUrlkey() || {};
    },
    // Push the selected variant into the product URL.
    updateProductUrl: function (current_variant) {
        var currentSearch = productInter.getUrlParams(),
            query = "?";

        if (!current_variant || !current_variant.value) return;
        currentSearch["variant"] = current_variant.value;

        for (var key in currentSearch) {
            if (!Object.prototype.hasOwnProperty.call(currentSearch, key)) continue;
            query += encodeURIComponent(key) + "=" + encodeURIComponent(currentSearch[key]) + "&";
        }

        history.pushState({}, "", query.substr(0, query.length - 1));
    },
    // Update the variant-specific pre-order line item property.
    updateProductProperties: function (batches) {
        var preOrderInput = document.getElementById("itemProperties_preOrderDescription"),
            currentBatch = batches.length ? batches[batches.length - 1] : null;

        if (preOrderInput && currentBatch && currentBatch.estimatedShippingDate) {
            preOrderInput.disabled = false;
            preOrderInput.value = currentBatch.estimatedShippingDate;
        } else {
            chairUtils.setDisabled(preOrderInput, true);
            chairUtils.setValue(preOrderInput, "");
        }
    },
    // Toggle shipping/service snippets based on pre-order status.
    updateShippingInfo: function (batches) {
        var isPreOrder = productInter.isPreOrderVariant(batches),
            shippingTime = document.getElementById("chair-product-shipping-time"),
            serviceSameDay = document.getElementById("chair-product-service-same-day");

        chairUtils.setDisplay(shippingTime, isPreOrder ? "none" : "flex");
        chairUtils.setDisplay(serviceSameDay, isPreOrder ? "none" : "");
    },
    // Update cart, inventory, and notify-me UI for the selected variant.
    updateAvailabilityState: function (current_variant, batches) {
        var cart = document.getElementById("chair-product-cart"),
            notifymeContainer = document.getElementById("chair-product-notify"),
            cartBtn = document.getElementById("chair-product-add-to-cart"),
            inventory = document.getElementById("chair-product-inventory"),
            shippingInfo = document.getElementById("chair-product-shipping"),
            isAvailable = current_variant && current_variant.dataset.available == "true",
            isPreOrder = productInter.isPreOrderVariant(batches),
            quantity = parseInt(current_variant && current_variant.dataset.quantity, 10) || 0,
            lowInventoryNotify = document.getElementById("lowInventoryNotify");

        if (lowInventoryNotify) {
            var warningType = lowInventoryNotify.dataset.lin,
                warningTrigger = parseInt(lowInventoryNotify.dataset.linTrigger, 10) || 0,
                inventoryText = "In stock";
            if (quantity > 0 && quantity <= warningTrigger) {
                if (warningType == "number") inventoryText = quantity + " in stock, order soon";
                if (warningType == "text") inventoryText = "Limited stock available";
            }
            lowInventoryNotify.textContent = inventoryText;
        }

        if (isAvailable) {
            chairUtils.setDisplay(cart, "block");
            chairUtils.setDisplay(notifymeContainer, "none");
            chairUtils.setDisplay(shippingInfo, "block");

            if (isPreOrder) {
                chairUtils.toggleClass(cart, "is-preordering", true);
                if (cartBtn) {
                    cartBtn.classList.remove("is-active", "is-adding");
                    cartBtn.classList.add("is-preorder");
                    cartBtn.disabled = false;
                }
                if (inventory) {
                    inventory.classList.remove("is-in-stock", "is-out-of-stock");
                    inventory.classList.add("is-checking-stock");
                }
                productInter.updatePreOrderInfo(batches, current_variant.dataset.quantity);
            } else {
                if (cartBtn) {
                    cartBtn.classList.remove("is-preorder", "is-adding");
                    cartBtn.classList.add("is-active");
                    cartBtn.disabled = false;
                }
                if (inventory) {
                    inventory.classList.remove("is-out-of-stock", "is-checking-stock");
                    inventory.classList.add("is-in-stock");
                }
                chairUtils.toggleClass(cart, "is-preordering", false);
                productInter.updatePreOrderInfo([], 0);
            }
            return;
        }

        var notifymeData = document.getElementById("chair-product-notify-email");
        if (inventory) {
            inventory.classList.remove("is-in-stock", "is-checking-stock");
            inventory.classList.add("is-out-of-stock");
        }
        chairUtils.setDisplay(shippingInfo, "block");
        chairUtils.setDisplay(cart, "none");
        if (notifymeData && current_variant) {
            notifymeData.dataset.region = window.Boulies && window.Boulies.setting ? window.Boulies.setting.region : "";
            notifymeData.dataset.itemName = current_variant.dataset.productSeries || "";
            notifymeData.dataset.itemColor = current_variant.dataset.options || [current_variant.dataset.option2, current_variant.dataset.option3].filter(Boolean).join(" / ");
            notifymeData.dataset.itemSku = current_variant.id || current_variant.value || "";
        }
        chairUtils.setDisplay(notifymeContainer, "block");
    },
    // Render customizable offer text and emphasize each [code] placeholder.
    renderPromotionMessage: function (messageNode, offerText, promotionCode) {
        if (!messageNode) return;

        var parts = String(offerText || "").split("[code]");
        messageNode.textContent = "";
        parts.forEach(function (part, index) {
            messageNode.appendChild(document.createTextNode(part));
            if (index >= parts.length - 1) return;

            var codeNode = document.createElement("span");
            codeNode.className = "chair-product-promotion__code";
            codeNode.textContent = promotionCode;
            messageNode.appendChild(codeNode);
        });
    },
    // Keep manual coupon messaging separate from Shopify's variant price.
    updatePromotionDisplay: function (current_variant) {
        var pricesWrap = document.getElementById("chair-product-price"),
            variantPrice = parseInt(current_variant && current_variant.dataset.price, 10) || 0,
            compareAtPrice = parseInt(current_variant && current_variant.dataset.compareAtPrice, 10) || 0,
            hasCompareAtPrice = compareAtPrice > variantPrice,
            promotionCode = (current_variant && current_variant.dataset.promotionCode) || "",
            offerText = (current_variant && current_variant.dataset.promotionOfferText) || "",
            hasPromotionOffer = !!(promotionCode && offerText),
            promotionRow = document.getElementById("chair-product-promotion-code-row"),
            promotionMessage = document.getElementById("chair-product-promotion-message"),
            copyButton = document.querySelector('[data-chair-product-action="copy-promotion-code"]');

        chairUtils.setText(document.getElementById("chair-product-current-price"), chairUtils.formatPrice(variantPrice));
        chairUtils.setText(document.getElementById("b5-collection__old_price"), hasCompareAtPrice ? chairUtils.formatPrice(compareAtPrice) : "");
        chairUtils.toggleClass(pricesWrap, "b5-on-sale-price", hasCompareAtPrice);

        chairUtils.toggleClass(promotionRow, "is-hidden", !hasPromotionOffer);
        productInter.renderPromotionMessage(promotionMessage, hasPromotionOffer ? offerText : "", promotionCode);

        if (copyButton) {
            chairUtils.setText(copyButton.querySelector('[data-chair-product-role="copy-promotion-label"]'), "Copy Code");
            copyButton.dataset.promotionCode = hasPromotionOffer ? promotionCode : "";
            copyButton.disabled = !hasPromotionOffer;
        }

        productInter.initSaleCodeAutoScroll();
    },
    // Resolve dimensions within the currently displayed description, including variant content.
    getDimensionsTarget: function () {
        var descriptions = document.querySelectorAll("#chair-product-description-default, [data-chair-product-description]");
        for (var i = 0; i < descriptions.length; i++) {
            var description = descriptions[i];
            if (description.hidden || !description.getClientRects().length) continue;
            var candidates = description.querySelectorAll('[id="product-dimensions"], .bt51-dimensions-list');
            for (var j = 0; j < candidates.length; j++) {
                if (!candidates[j].getClientRects().length) continue;
                return candidates[j].closest(".bprtdd_detail_line") || candidates[j];
            }
            var headings = description.querySelectorAll("h2, h3, h4");
            for (var k = 0; k < headings.length; k++) {
                if (/^dimensions$/i.test(headings[k].textContent.trim()) && headings[k].getClientRects().length) {
                    return headings[k].closest(".bprtdd_detail_line") || headings[k];
                }
            }
        }
        return null;
    },
    initDimensionsLink: function () {
        var link = document.querySelector(".chair-product-heading__dimensions");
        if (!link || link.dataset.dimensionsReady == "true") return;
        link.dataset.dimensionsReady = "true";
        link.addEventListener("click", function (event) {
            var target = productInter.getDimensionsTarget();
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView();
        });
    },
    // Switch to the selected description; shared metaobjects are rendered only once.
    updateProductDescription: function (current_variant) {
        var hasCustomDescription = false;
        document.querySelectorAll("[data-chair-product-description]").forEach(function (description) {
            var active = !!current_variant && description.dataset.chairProductDescription == current_variant.dataset.descriptionId;
            description.hidden = !active;
            if (active) hasCustomDescription = true;
        });
        var defaultDescription = document.getElementById("chair-product-description-default");
        if (defaultDescription) defaultDescription.hidden = hasCustomDescription;
        $(".slick-initialized:visible").slick("setPosition");
    },
    // Coordinate all UI updates for the selected variant.
    changeToThisOption: function (current_variant, stopPopstate) {
        if (!current_variant) return;

        var preorderBatches = productInter.getVariantPreorderBatches(current_variant);

        productInter.updateProductGallery(current_variant.id);
        if (!stopPopstate) productInter.updateProductUrl(current_variant);
        productInter.updateProductSubtitle(current_variant);
        productInter.updateProductProperties(preorderBatches);
        productInter.updateShippingInfo(preorderBatches);
        productInter.updateAvailabilityState(current_variant, preorderBatches);
        productInter.updatePromotionDisplay(current_variant);
        productInter.updateProductDescription(current_variant);
        productInter.setAddToCartLoading(productInter.isAddingToCart);
    },
    variantsMap: {},
    // Build model/upholstery/color lookup from variant inputs.
    makeVariantsMap: function () {
        productInter.variantsMap = {};

        document.querySelectorAll('[data-chair-product-role="variant"]').forEach(function (variant) {
            var option1 = variant.dataset.option1,
                option2 = variant.dataset.option2,
                final_price = parseInt(variant.dataset.price, 10);

            if (!option1 || !option2) return;
            if (!productInter.variantsMap[option1]) productInter.variantsMap[option1] = {};
            if (productInter.variantsMap[option1][option2] === undefined) {
                productInter.variantsMap[option1][option2] = [];
            }

            productInter.variantsMap[option1][option2].push({
                sku: variant.id,
                price: isNaN(final_price) ? 0 : final_price,
                model: option1,
                upholstery: option2,
                color: variant.dataset.option3,
            });
        });
    },
    // Render model and upholstery option controls on first load.
    sortOptionsOnFirstLoad: function () {
        var models = Object.keys(productInter.variantsMap),
            upholsterys = [],
            models_HTML = "",
            upholsterys_HTML = "",
            default_variant = document.querySelector('[data-chair-product-role="variant"]:checked'),
            default_model,
            default_upholstery,
            productModelList = document.getElementById("product-model-list");

        if (default_variant) {
            default_model = default_variant.dataset.option1;
            default_upholstery = default_variant.dataset.option2;
        } else {
            var variants = document.querySelectorAll('[data-chair-product-role="variant"]'),
                default_option = productModelList && productModelList.dataset.defaultOption ? productModelList.dataset.defaultOption.split(" / ") : [],
                weighted_variants = [];

            if (!variants.length) return;

            for (var i = 0; i < variants.length; i++) {
                if (variants[i].dataset.option1 == default_option[0] && variants[i].dataset.option2 == default_option[1]) {
                    weighted_variants.push({
                        node: variants[i],
                        weight: 2,
                    });
                } else if (variants[i].dataset.option1 == default_option[0]) {
                    weighted_variants.push({
                        node: variants[i],
                        weight: 1,
                    });
                } else {
                    weighted_variants.push({
                        node: variants[i],
                        weight: 0,
                    });
                }
            }
            weighted_variants.sort(function (a, b) {
                return b.weight - a.weight;
            });
            weighted_variants[0].node.checked = true;
            default_model = weighted_variants[0].node.dataset.option1;
            default_upholstery = weighted_variants[0].node.dataset.option2;
        }

        for (var i = 0; i < models.length; i++) {
            var model_upholsterys = Object.keys(productInter.variantsMap[models[i]]);
            if (model_upholsterys.length == 0) continue;
            var is_checked = "";
            for (var n = 0; n < model_upholsterys.length; n++) {
                if (upholsterys.indexOf(model_upholsterys[n]) !== -1) continue;
                upholsterys.push(model_upholsterys[n]);
            }
            if (models[i] == default_model) {
                is_checked = 'checked="checked"';
            }
            models_HTML += '<input type="radio" ' + is_checked + ' class="chair-product-model__input" data-chair-product-role="model" name="product-model" id="chair-product-model-' + i + '" value="' + productInter.escapeHtml(models[i]) + '"> <label for="chair-product-model-' + i + '" class="chair-product-model__label" data-chair-product-role="model-label" data-value="' + productInter.escapeHtml(models[i]) + '"><span class="chair-product-model__name" data-chair-product-role="option-name">' + productInter.escapeHtml(models[i]) + "</span></label>";
        }

        for (var i = 0; i < upholsterys.length; i++) {
            var upholstery_preview = "",
                upholsteryImage = chairPageData.upholsteryImages[upholsterys[i]],
                is_checked = "";
            if (upholsteryImage) {
                upholstery_preview = 'style="background-image:url(' + productInter.escapeHtml(upholsteryImage) + ')"';
            }
            if (upholsterys[i] == default_upholstery) {
                is_checked = 'checked="checked"';
            }
            upholsterys_HTML += '<input type="radio" ' + is_checked + ' class="chair-product-upholstery__input" data-chair-product-role="upholstery" name="product-upholstery" id="chair-product-upholstery-' + i + '" value="' + productInter.escapeHtml(upholsterys[i]) + '"> <label for="chair-product-upholstery-' + i + '" class="chair-product-upholstery__label" data-chair-product-role="upholstery-label" data-value="' + productInter.escapeHtml(upholsterys[i]) + '" ' + upholstery_preview + '><span class="chair-product-upholstery__name" data-chair-product-role="option-name">' + productInter.escapeHtml(upholsterys[i]) + "</span></label>";
        }

        if (productModelList) productModelList.innerHTML = models_HTML;
        var upholsteryList = document.getElementById("product-upholstery-list");
        if (upholsteryList) upholsteryList.innerHTML = upholsterys_HTML;
    },
    // Sync upholstery options after model changes.
    changeUpholstery: function (stop_active_first_element) {
        var checkedModel = document.querySelector('[data-chair-product-role="model"]:checked');
        if (!checkedModel) return;

        var model_value = checkedModel.value,
            modelOptions = productInter.variantsMap[model_value] || {},
            upholstery_input = document.querySelectorAll('[data-chair-product-role="upholstery"]');

        document.querySelectorAll('[data-chair-product-role="upholstery-label"]').forEach(function (upholstery, index) {
            if (modelOptions[upholstery.dataset.value] === undefined) {
                upholstery.style.display = "none";
                if (upholstery_input[index]) upholstery_input[index].disabled = true;
            } else {
                upholstery.style.display = "block";
                if (upholstery_input[index]) upholstery_input[index].disabled = false;
            }
        });
        if (!stop_active_first_element) {
            var firstEnabledUpholstery = document.querySelector('[data-chair-product-role="upholstery"]:enabled');
            if (firstEnabledUpholstery) firstEnabledUpholstery.checked = true;
            productInter.changeVariants(stop_active_first_element);
        } else {
            productInter.changeVariants(stop_active_first_element);
        }
        productInter.refreshOptionDropdowns();
    },
    // Sync visible color variants after upholstery changes.
    changeVariants: function (stop_active_first_element) {
        var checkedModel = document.querySelector('input[name="product-model"]:checked'),
            checkedUpholstery = document.querySelector('input[name="product-upholstery"]:checked');
        if (!checkedModel || !checkedUpholstery) return;

        var model_value = checkedModel.value;
        var upholstery_value = checkedUpholstery.value;
        var variant_input = document.querySelectorAll('[data-chair-product-role="variant"]');
        document.querySelectorAll('[data-chair-product-role="variant-label"]').forEach(function (variant, index) {
            if (variant.dataset.option1 == model_value && variant.dataset.option2 == upholstery_value) {
                variant.style.display = "block";
                if (variant_input[index]) variant_input[index].disabled = false;
            } else {
                variant.style.display = "none";
                if (variant_input[index]) variant_input[index].disabled = true;
            }
        });
        if (!stop_active_first_element) {
            var firstEnabledVariant = document.querySelector('[data-chair-product-role="variant"]:enabled');
            if (firstEnabledVariant) firstEnabledVariant.checked = true;
            productInter.changeToThisOption(document.querySelector('input[name="id"]:checked'));
        } else {
            productInter.changeToThisOption(document.querySelector('[data-chair-product-role="variant"]:checked'), true);
        }
        productInter.refreshOptionDropdowns();
    },
    // Sync dropdown trigger text and expanded state.
    syncOptionDropdown: function (section) {
        if (!section) return;
        var trigger = section.querySelector('[data-chair-product-action="toggle-option"]');
        if (!trigger) return;

        var currentText = trigger.querySelector('[data-chair-product-role="option-current"]');
        if (!currentText) {
            currentText = document.createElement("span");
            currentText.className = "chair-product-options__current";
            currentText.dataset.chairProductRole = "option-current";
            trigger.appendChild(currentText);
        }

        var checkedInput = section.querySelector("input:checked"),
            checkedLabel = checkedInput ? checkedInput.nextElementSibling : null,
            nameNode = checkedLabel ? checkedLabel.querySelector('[data-chair-product-role="option-name"]') : null;

        if (nameNode && nameNode.classList.contains("chair-product-warranty__name") && nameNode.children.length) {
            currentText.textContent = "";
            Array.prototype.slice.call(nameNode.children).forEach(function (child) {
                currentText.appendChild(child.cloneNode(true));
            });
        } else {
            currentText.textContent = (nameNode ? nameNode.textContent : checkedInput ? checkedInput.value : "").trim();
        }

        trigger.setAttribute("aria-expanded", section.classList.contains("is-open") ? "true" : "false");
    },
    // Close all option dropdowns except the provided section.
    closeOptionDropdowns: function (exceptSection) {
        document.querySelectorAll('[data-chair-product-role="option-dropdown"].is-open').forEach(function (section) {
            if (section === exceptSection) return;
            section.classList.remove("is-open");
            productInter.syncOptionDropdown(section);
        });
    },
    // Open a single option dropdown when it is selectable.
    openOptionDropdown: function (section) {
        if (!section || section.classList.contains("is-hidden") || section.classList.contains("is-single")) return;
        productInter.closeOptionDropdowns(section);
        section.classList.add("is-open");
        productInter.syncOptionDropdown(section);
    },
    // Refresh dropdown visibility and current labels.
    refreshOptionDropdowns: function () {
        var modelSection = document.querySelector('[data-chair-product-option-group="model"]');
        if (modelSection) {
            var modelInputs = modelSection.querySelectorAll('[data-chair-product-role="model"]'),
                hasSingleModel = modelInputs.length <= 1,
                modelTrigger = modelSection.querySelector('[data-chair-product-action="toggle-option"]');

            modelSection.classList.toggle("is-hidden", hasSingleModel);
            modelSection.classList.toggle("is-single", hasSingleModel);

            if (hasSingleModel) {
                modelSection.classList.remove("is-open");
            }

            if (modelTrigger) {
                modelTrigger.setAttribute("aria-disabled", hasSingleModel ? "true" : "false");
            }
        }

        document.querySelectorAll('[data-chair-product-role="option-dropdown"]').forEach(function (section) {
            var enabledInputs = Array.prototype.filter.call(section.querySelectorAll("input"), function (input) {
                return !input.disabled;
            });
            section.classList.toggle("is-one-option", enabledInputs.length <= 1);
            productInter.syncOptionDropdown(section);
        });
    },
    // Initialize option dropdown triggers and close handlers.
    setupOptionDropdowns: function () {
        document.querySelectorAll('[data-chair-product-role="option-dropdown"]').forEach(function (section) {
            section.classList.add("chair-product-options__dropdown");

            var fieldset = section.querySelector("fieldset"),
                trigger = section.querySelector('[data-chair-product-action="toggle-option"]');

            if (!trigger) {
                trigger = document.createElement("button");
                trigger.type = "button";
                trigger.className = "chair-product-options__trigger";
                trigger.dataset.chairProductAction = "toggle-option";
                trigger.innerHTML = '<span class="chair-product-options__current" data-chair-product-role="option-current"></span>';
                section.insertBefore(trigger, fieldset || null);
            }

            if (fieldset && fieldset.id) {
                trigger.setAttribute("aria-controls", fieldset.id);
            }
            trigger.setAttribute("aria-expanded", "false");
            trigger.addEventListener("click", function () {
                if (section.classList.contains("is-single")) return;

                if (section.classList.contains("is-open")) {
                    productInter.closeOptionDropdowns();
                } else {
                    productInter.openOptionDropdown(section);
                }
            });

            if (fieldset) {
                fieldset.setAttribute("tabindex", "0");
            }

            var modalIds = {
                    model: "chair-product-guide-modal",
                    upholstery: "chair-product-upholstery-modal",
                    warranty: "chair-product-warranty-modal"
                },
                modal = document.getElementById(modalIds[section.dataset.chairProductOptionGroup]),
                modalTitle = modal && document.getElementById(modal.getAttribute("aria-labelledby"));
            if (fieldset && modalTitle && modalTitle.textContent.trim() && !fieldset.querySelector(".chair-product-options__details")) {
                var detailsButton = document.createElement("button");
                detailsButton.type = "button";
                detailsButton.className = "chair-product-options__details";
                detailsButton.dataset.chairProductAction = "open-promotion";
                detailsButton.setAttribute("aria-haspopup", "dialog");
                detailsButton.setAttribute("aria-controls", modal.id);
                detailsButton.setAttribute("aria-expanded", "false");
                detailsButton.textContent = modalTitle.textContent.trim();
                fieldset.appendChild(detailsButton);
            }

            if (fieldset) {
                fieldset.addEventListener("click", function (event) {
                    var target = event.target,
                        label = target.closest ? target.closest("label") : null;

                    if (label) {
                        setTimeout(function () {
                            productInter.refreshOptionDropdowns();
                            productInter.closeOptionDropdowns();
                        }, 0);
                    }
                });
            }
        });

        document.addEventListener("click", function (event) {
            if (event.target.closest && event.target.closest('[data-chair-product-role="option-dropdown"]')) return;
            productInter.closeOptionDropdowns();
        });

        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape") return;
            productInter.closeOptionDropdowns();
        });

        productInter.refreshOptionDropdowns();
    },
    promotionModalLastTrigger: null,
    promotionModalOpenTimer: null,
    promotionModalCloseTimer: null,
    promotionModalScrollY: 0,
    promotionModalScrollLocked: false,
    promotionModalStickyGallery: null,
    promotionModalStickyGalleryTop: 0,
    promotionModalActive: null,
    promotionModalInteractionsReady: false,
    getPromotionModalTransitionDuration: function () {
        return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 500;
    },
    // Keep the desktop sticky gallery visually fixed while the root scroll container is locked.
    updatePromotionModalStickyGallery: function () {
        var gallery = productInter.promotionModalStickyGallery;
        if (!gallery) return;

        gallery.classList.remove("is-drawer-scroll-locked");
        gallery.style.removeProperty("--chair-product-gallery-drawer-offset");
        if (window.getComputedStyle(gallery).position != "sticky") return;

        var lockedTop = gallery.getBoundingClientRect().top,
            offset = productInter.promotionModalStickyGalleryTop - lockedTop;

        if (Math.abs(offset) <= 0.5) return;
        gallery.style.setProperty("--chair-product-gallery-drawer-offset", offset + "px");
        gallery.classList.add("is-drawer-scroll-locked");
    },
    lockPromotionModalScroll: function (modal) {
        var body = document.body,
            gallery = modal && modal.classList.contains("chair-product-info-drawer") ? document.querySelector(".chair-product-gallery") : null;
        if (!body || productInter.promotionModalScrollLocked) return;

        productInter.promotionModalStickyGallery = null;
        if (gallery && window.getComputedStyle(gallery).position == "sticky") {
            productInter.promotionModalStickyGallery = gallery;
            productInter.promotionModalStickyGalleryTop = gallery.getBoundingClientRect().top;
        }

        productInter.promotionModalScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        document.documentElement.classList.add("chair-product-promotion-scroll-lock");
        body.classList.add("chair-product-promotion-scroll-lock");
        productInter.promotionModalScrollLocked = true;
        productInter.updatePromotionModalStickyGallery();
    },
    unlockPromotionModalScroll: function () {
        var body = document.body,
            root = document.documentElement,
            scrollY = productInter.promotionModalScrollY,
            previousScrollBehavior,
            gallery = productInter.promotionModalStickyGallery;

        if (!body || !productInter.promotionModalScrollLocked) return;

        root.classList.remove("chair-product-promotion-scroll-lock");
        body.classList.remove("chair-product-promotion-scroll-lock");
        productInter.promotionModalScrollLocked = false;

        previousScrollBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = "auto";
        window.scrollTo(0, scrollY);
        if (gallery) {
            gallery.classList.remove("is-drawer-scroll-locked");
            gallery.style.removeProperty("--chair-product-gallery-drawer-offset");
        }
        productInter.promotionModalStickyGallery = null;
        window.setTimeout(function () {
            root.style.scrollBehavior = previousScrollBehavior;
        }, 0);
    },
    getPromotionModalFocusableElements: function (modal) {
        if (!modal) return [];
        return Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    },
    trapPromotionModalFocus: function (event, modal) {
        var focusableElements,
            firstElement,
            lastElement;

        if (event.key != "Tab" || !modal || modal.getAttribute("aria-hidden") == "true") return;
        focusableElements = productInter.getPromotionModalFocusableElements(modal);
        if (!focusableElements.length) {
            event.preventDefault();
            modal.focus({ preventScroll: true });
            return;
        }

        firstElement = focusableElements[0];
        lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey && (document.activeElement == firstElement || !modal.contains(document.activeElement))) {
            event.preventDefault();
            lastElement.focus({ preventScroll: true });
        } else if (!event.shiftKey && (document.activeElement == lastElement || !modal.contains(document.activeElement))) {
            event.preventDefault();
            firstElement.focus({ preventScroll: true });
        }
    },
    copySaleCode: function (button) {
        var code = button && button.dataset ? (button.dataset.promotionCode || "").trim() : "",
            label = button ? button.querySelector('[data-chair-product-role="copy-promotion-label"]') : null;

        if (!button || !label || !code) return;

        var showCopied = function () {
            label.textContent = "Copied";
            window.clearTimeout(productInter.copySaleCodeTimer);
            productInter.copySaleCodeTimer = window.setTimeout(function () {
                label.textContent = "Copy Code";
            }, 1600);
        };

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard
                .writeText(code)
                .then(showCopied)
                .catch(function () {
                    productInter.copySaleCodeFallback(code, showCopied);
                });
            return;
        }

        productInter.copySaleCodeFallback(code, showCopied);
    },
    copySaleCodeFallback: function (code, onSuccess) {
        var input = document.createElement("textarea");
        input.value = code;
        input.setAttribute("readonly", "");
        input.style.position = "fixed";
        input.style.opacity = "0";
        document.body.appendChild(input);
        input.select();
        try {
            if (document.execCommand("copy")) onSuccess();
        } catch (error) {
            // The code remains visible for manual copying.
        }
        input.remove();
    },
    // Keep open FAQ heights aligned with their rich-text content.
    syncProductFaqHeights: function (root) {
        (root || document).querySelectorAll(".chair-product-faq__item.is-open .chair-product-faq__answer").forEach(function (answer) {
            answer.style.maxHeight = answer.scrollHeight + "px";
        });
    },
    // Open or close one FAQ item without changing the other items.
    setProductFaqItem: function (item, shouldOpen) {
        var trigger = item ? item.querySelector(".chair-product-faq__trigger") : null,
            answer = item ? item.querySelector(".chair-product-faq__answer") : null;
        if (!item || !trigger || !answer) return;

        if (shouldOpen) {
            item.classList.add("is-open");
            answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
            item.classList.remove("is-open");
            answer.style.maxHeight = "0px";
        }
        trigger.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
        answer.setAttribute("aria-hidden", shouldOpen ? "false" : "true");
    },
    // Initialize FAQ states before the drawer is opened.
    initProductFaqs: function () {
        document.querySelectorAll(".chair-product-faq__item").forEach(function (item) {
            productInter.setProductFaqItem(item, item.classList.contains("is-open"));
        });
    },
    // Toggle only the selected FAQ so multiple answers may stay open.
    toggleProductFaq: function (trigger) {
        var item = trigger && trigger.closest ? trigger.closest(".chair-product-faq__item") : null,
            shouldOpen = trigger && trigger.getAttribute("aria-expanded") != "true";
        if (!item) return;

        productInter.setProductFaqItem(item, shouldOpen);
    },
    // Position an information drawer below only the visible portion of the site header.
    updateInfoDrawerPosition: function (modal) {
        if (!modal || !modal.classList.contains("chair-product-info-drawer")) return;

        var header = document.querySelector("header.bt5-header"),
            drawerTop = 0;

        if (header) {
            var headerRect = header.getBoundingClientRect();
            if (headerRect.bottom > 0 && headerRect.top < window.innerHeight) {
                drawerTop = Math.max(0, Math.min(headerRect.bottom, window.innerHeight));
            }
        }

        modal.style.setProperty("--chair-product-info-drawer-top", drawerTop + "px");
    },
    openPromotionModal: function (trigger) {
        var modalId = trigger && trigger.getAttribute("aria-controls"),
            modal = document.getElementById(modalId || "chair-product-promotion-modal"),
            closeButton;
        if (!modal) return;

        window.clearTimeout(productInter.promotionModalOpenTimer);
        window.clearTimeout(productInter.promotionModalCloseTimer);
        productInter.promotionModalLastTrigger = trigger || document.activeElement;
        if (trigger && trigger.classList.contains("chair-product-options__details")) {
            productInter.closeOptionDropdowns();
        }
        productInter.promotionModalActive = modal;
        productInter.updateInfoDrawerPosition(modal);
        modal.style.display = "flex";
        modal.setAttribute("aria-hidden", "false");
        productInter.syncProductFaqHeights(modal);
        if (trigger) trigger.setAttribute("aria-expanded", "true");
        productInter.lockPromotionModalScroll(modal);

        closeButton = modal.querySelector('[data-chair-product-action="close-promotion"]');
        productInter.promotionModalOpenTimer = window.setTimeout(function () {
            modal.classList.add("is-active");
            var focusModal = function () {
                var focusTarget = closeButton || modal;
                if (modal.getAttribute("aria-hidden") == "true") return;
                focusTarget.focus({ preventScroll: true });
            };

            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(focusModal);
            } else {
                window.setTimeout(focusModal, 0);
            }
        }, 20);
    },
    closePromotionModal: function (modal, onClosed) {
        modal = modal || productInter.promotionModalActive;
        var trigger = productInter.promotionModalLastTrigger,
            closeDelay = productInter.getPromotionModalTransitionDuration();
        if (!modal || modal.getAttribute("aria-hidden") == "true") return;

        window.clearTimeout(productInter.promotionModalOpenTimer);
        window.clearTimeout(productInter.promotionModalCloseTimer);
        modal.classList.remove("is-active");
        modal.setAttribute("aria-hidden", "true");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        productInter.promotionModalLastTrigger = null;
        productInter.promotionModalActive = null;
        productInter.promotionModalCloseTimer = window.setTimeout(function () {
            modal.style.display = "none";
            modal.style.removeProperty("--chair-product-info-drawer-top");
            productInter.unlockPromotionModalScroll();
            var dropdown = trigger && trigger.classList.contains("chair-product-options__details") ? trigger.closest('[data-chair-product-role="option-dropdown"]') : null,
                focusTarget = dropdown ? dropdown.querySelector('[data-chair-product-action="toggle-option"]') : trigger;
            if (focusTarget && typeof focusTarget.focus == "function") focusTarget.focus({ preventScroll: true });
            if (typeof onClosed == "function") onClosed();
        }, closeDelay);
    },
    // Promotion-code copying is independent of modal availability.
    initPromotionCodeCopy: function () {
        var copyButton = document.querySelector('[data-chair-product-action="copy-promotion-code"]');
        if (!copyButton || copyButton.dataset.promotionCopyReady == "true") return;
        copyButton.dataset.promotionCopyReady = "true";
        copyButton.addEventListener("click", function () {
            productInter.copySaleCode(this);
        });
    },
    // Modal open, close, keyboard and focus behavior.
    initPromotionModal: function () {
        if (!document.querySelector(".chair-product-modal") || productInter.promotionModalInteractionsReady) return;
        productInter.promotionModalInteractionsReady = true;

        document.addEventListener("click", function (event) {
            var openTrigger = event.target.closest ? event.target.closest('[data-chair-product-action="open-promotion"]') : null,
                faqTrigger = event.target.closest ? event.target.closest('[data-chair-product-action="toggle-faq"]') : null,
                closeTrigger = event.target.closest ? event.target.closest('[data-chair-product-action="close-promotion"], [data-chair-product-action="close-info-drawer"]') : null,
                modal = event.target.closest ? event.target.closest(".chair-product-modal") : null,
                anchorTarget;
            if (openTrigger) {
                event.preventDefault();
                productInter.openPromotionModal(openTrigger);
                return;
            }
            if (faqTrigger) {
                event.preventDefault();
                productInter.toggleProductFaq(faqTrigger);
                return;
            }
            if (closeTrigger || (modal && event.target === modal)) {
                event.preventDefault();
                if (closeTrigger && closeTrigger.tagName == "A") {
                    anchorTarget = closeTrigger.getAttribute("href") == "#product-dimensions"
                        ? productInter.getDimensionsTarget()
                        : document.querySelector(closeTrigger.getAttribute("href"));
                }
                productInter.closePromotionModal(modal, function () {
                    if (anchorTarget) anchorTarget.scrollIntoView();
                });
            }
        });

        document.addEventListener("keydown", function (event) {
            var modal = productInter.promotionModalActive;
            if (!modal) return;
            if (event.key == "Escape" && modal.getAttribute("aria-hidden") == "false") {
                event.preventDefault();
                productInter.closePromotionModal(modal);
                return;
            }
            productInter.trapPromotionModalFocus(event, modal);
        });

        window.addEventListener("resize", function () {
            productInter.updateInfoDrawerPosition(productInter.promotionModalActive);
            productInter.updatePromotionModalStickyGallery();
            if (productInter.promotionModalActive) {
                productInter.syncProductFaqHeights(productInter.promotionModalActive);
            }
        });
    },
    // Initialize promotion features without coupling their availability.
    initPromotionInteractions: function () {
        productInter.initPromotionCodeCopy();
        productInter.initProductFaqs();
        productInter.initPromotionModal();
    },
    // Update subtitle from upholstery and color options.
    updateProductSubtitle: function (current_variant) {
        var subtitle = document.getElementById("chair-product-subtitle");
        if (!subtitle || !current_variant) return;

        var optionParts = [current_variant.dataset.option2, current_variant.dataset.option3].filter(function (option) {
            return option && option.trim();
        });
        subtitle.textContent = optionParts.join(" / ");
    },
    // Format warranty addon product price from the selected addon variant.
    formatWarrantyAddonPrice: function (item, warrantyVariant) {
        var priceRaw = warrantyVariant ? warrantyVariant.price : item && item.price,
            compareAtRaw = warrantyVariant ? warrantyVariant.compare_at_price : item && item.compare_at_price,
            priceValue = parseInt(priceRaw, 10),
            compareAtValue = parseInt(compareAtRaw, 10),
            priceData = {
                price: "",
                compareAt: "",
            };

        if (isNaN(priceValue)) return priceData;

        priceData.price = chairUtils.formatPrice(priceValue);
        if (!isNaN(compareAtValue) && compareAtValue > priceValue) {
            priceData.compareAt = chairUtils.formatPrice(compareAtValue);
        }

        return priceData;
    },
    // Render warranty addon label with optional compare-at price.
    renderWarrantyAddonOption: function (addonLabel, term, priceData) {
        var optionName = addonLabel ? addonLabel.querySelector('[data-chair-product-role="option-name"]') : null,
            termNode,
            priceWrap,
            compareAtNode,
            currentPriceNode;

        if (!optionName) return;

        optionName.textContent = "";

        termNode = document.createElement("span");
        termNode.className = "chair-product-warranty__term";
        termNode.textContent = term || "+1 year";
        optionName.appendChild(termNode);

        if (!priceData || !priceData.price) return;

        priceWrap = document.createElement("span");
        priceWrap.className = "chair-product-warranty__price";

        currentPriceNode = document.createElement("span");
        currentPriceNode.className = "chair-product-warranty__current-price";
        currentPriceNode.textContent = priceData.price;
        priceWrap.appendChild(currentPriceNode);

        if (priceData.compareAt) {
            compareAtNode = document.createElement("span");
            compareAtNode.className = "chair-product-warranty__compare-price";
            compareAtNode.textContent = priceData.compareAt;
            priceWrap.appendChild(compareAtNode);
        }

        optionName.appendChild(priceWrap);
    },
    // Infer display term from warranty product text.
    getWarrantyAddonTerm: function (item, warrantyVariant, warrantyHandle) {
        var sourceText = [warrantyVariant && warrantyVariant.title, item && item.title, warrantyHandle, item && item.description].filter(Boolean).join(" "),
            yearMatch = sourceText.match(/(\d+(?:\.\d+)?)\s*(?:year|years|yr|yrs)/i),
            monthMatch;

        if (yearMatch) return "+" + yearMatch[1] + (yearMatch[1] == "1" ? " year" : " years");

        monthMatch = sourceText.match(/(\d+)\s*(?:months|month|mo)/i);
        if (monthMatch) {
            var months = parseInt(monthMatch[1], 10);
            if (!isNaN(months) && months % 12 === 0) {
                var years = months / 12;
                return "+" + years + (years == 1 ? " year" : " years");
            }
            return "+" + monthMatch[1] + (monthMatch[1] == "1" ? " month" : " months");
        }

        return "+1 year";
    },
    // Show or hide the warranty addon dropdown option.
    updateWarrantyAddonDisplay: function (enabled, term, priceData, selected) {
        var warrantySection = document.getElementById("chair-product-warranty"),
            warrantyList = document.getElementById("chair-product-warranty-list"),
            noneInput = document.getElementById("chair-product-warranty-none"),
            addonInput = document.getElementById("chair-product-warranty-addon"),
            addonLabel = document.querySelector('label[for="chair-product-warranty-addon"]'),
            optionTerm = term || "+1 year",
            optionPriceData = priceData && typeof priceData == "object" ? priceData : null,
            shouldSelectAddon = selected === true;

        if (typeof priceData == "boolean" && selected == null) {
            shouldSelectAddon = priceData;
            optionPriceData = null;
        }

        if (warrantySection) {
            warrantySection.classList.toggle("is-hidden", !enabled);
        }

        if (!warrantyList) return;

        if (!enabled) {
            if (addonInput) addonInput.remove();
            if (addonLabel) addonLabel.remove();
            if (noneInput) noneInput.checked = true;
            productInter.setWarrantyAddonSelected(false);
            productInter.refreshOptionDropdowns();
            return;
        }

        if (!addonInput) {
            addonInput = document.createElement("input");
            addonInput.type = "radio";
            addonInput.className = "chair-product-warranty__input";
            addonInput.dataset.chairProductRole = "warranty";
            addonInput.name = "product-warranty-addon";
            addonInput.id = "chair-product-warranty-addon";
            addonInput.value = "addon";
            warrantyList.insertBefore(addonInput, warrantyList.querySelector(".chair-product-options__details"));
        }

        if (!addonLabel) {
            addonLabel = document.createElement("label");
            addonLabel.className = "chair-product-warranty__label";
            addonLabel.setAttribute("for", "chair-product-warranty-addon");
            addonLabel.innerHTML = '<span class="chair-product-warranty__name" data-chair-product-role="option-name"></span>';
            warrantyList.insertBefore(addonLabel, warrantyList.querySelector(".chair-product-options__details"));
        }

        productInter.renderWarrantyAddonOption(addonLabel, optionTerm, optionPriceData);
        if (noneInput) noneInput.checked = !shouldSelectAddon;
        addonInput.checked = shouldSelectAddon;
        productInter.setWarrantyAddonSelected(shouldSelectAddon);
        productInter.refreshOptionDropdowns();
    },
    // Wire warranty addon radio changes.
    setupWarrantyAddonDropdown: function () {
        var warrantySection = document.getElementById("chair-product-warranty"),
            warrantyList = document.getElementById("chair-product-warranty-list");

        if (!warrantySection || !warrantyList || warrantySection.dataset.warrantyDropdownReady == "true") return;

        warrantySection.dataset.warrantyDropdownReady = "true";
        warrantyList.addEventListener("change", function (event) {
            if (!event.target.matches || !event.target.matches('[data-chair-product-role="warranty"]')) return;
            productInter.setWarrantyAddonSelected(event.target.value == "addon");
            productInter.refreshOptionDropdowns();
        });

        productInter.setWarrantyAddonSelected(false);
    },
    // Check whether the warranty addon is selected in either UI layer.
    isWarrantyAddonSelected: function () {
        var addonInput = document.getElementById("chair-product-warranty-addon"),
            warrantySection = document.getElementById("chair-product-warranty");

        return !!((addonInput && addonInput.checked) || (warrantySection && warrantySection.classList.contains("is-selected")));
    },
    // Keep visible warranty option state in sync.
    setWarrantyAddonSelected: function (selected) {
        var warrantySection = document.getElementById("chair-product-warranty"),
            selectedChoice = document.getElementById(selected ? "chair-product-warranty-addon" : "chair-product-warranty-none");

        if (selectedChoice && !selectedChoice.disabled) {
            selectedChoice.checked = true;
        }

        if (warrantySection) {
            warrantySection.classList.toggle("is-selected", selected);
            productInter.syncOptionDropdown(warrantySection);
        }
    },
    // Read the product-level warranty reference rendered by Liquid.
    initWarrantyAddon: function () {
        var warrantySection = document.getElementById("chair-product-warranty"),
            warrantyVariantId = warrantySection ? warrantySection.dataset.warrantyAddonVariantId : "",
            isAvailable = warrantySection && warrantySection.dataset.warrantyAddonAvailable == "true";

        if (!warrantySection || !warrantyVariantId || !isAvailable) {
            productInter.warrantyAddonVariantId = "";
            productInter.updateWarrantyAddonDisplay(false);
            return;
        }

        var warrantyVariant = {
                id: warrantyVariantId,
                title: warrantySection.dataset.warrantyAddonVariantTitle || "",
                price: warrantySection.dataset.warrantyAddonPrice,
                compare_at_price: warrantySection.dataset.warrantyAddonCompareAtPrice,
            },
            warrantyProduct = {
                title: warrantySection.dataset.warrantyAddonProductTitle || "",
            },
            warrantyHandle = warrantySection.dataset.warrantyAddonHandle || "",
            addonPrice = productInter.formatWarrantyAddonPrice(warrantyProduct, warrantyVariant),
            warrantyTerm = productInter.getWarrantyAddonTerm(warrantyProduct, warrantyVariant, warrantyHandle);

        productInter.warrantyAddonVariantId = warrantyVariantId;
        productInter.updateWarrantyAddonDisplay(true, warrantyTerm, addonPrice, false);
    },
    // Measure the sticky bar so page padding and floating widgets share its real height.
    updateStickyPurchaseBarHeight: function () {
        var stickyBar = document.getElementById("chair-product-sticky-purchase"),
            height;

        if (!stickyBar || !document.body) return;
        var header = document.querySelector("header.bt5-header");
        if (header) document.body.style.setProperty("--chair-product-header-height", Math.ceil(header.getBoundingClientRect().height) + "px");
        height = Math.ceil(stickyBar.getBoundingClientRect().height);
        if (height > 0) document.body.style.setProperty("--chair-product-sticky-height", height + "px");
    },
    // Show the sticky bar only after the available main purchase button has passed above the viewport.
    updateStickyPurchaseBarVisibility: function () {
        var stickyBar = document.getElementById("chair-product-sticky-purchase"),
            stickyButton = document.getElementById("chair-product-sticky-add-to-cart"),
            cart = document.getElementById("chair-product-cart"),
            notify = document.getElementById("chair-product-notify"),
            mainButton = document.getElementById("chair-product-add-to-cart");

        if (!stickyBar || !document.body) return;

        var cartStyle = cart ? window.getComputedStyle(cart) : null,
            notifyStyle = notify ? window.getComputedStyle(notify) : null,
            cartVisible = !!(cart && cartStyle.display != "none" && cartStyle.visibility != "hidden"),
            notifyVisible = !!(notify && notifyStyle.display != "none" && notifyStyle.visibility != "hidden"),
            mainButtonPast = !!(mainButton && mainButton.getBoundingClientRect().bottom <= 0),
            shouldShow = cartVisible && !notifyVisible && mainButtonPast && !!mainButton;

        stickyBar.classList.toggle("is-visible", shouldShow);
        stickyBar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        document.body.classList.toggle("chair-product-sticky-purchase-visible", shouldShow);

        if (stickyButton) {
            stickyButton.tabIndex = shouldShow ? 0 : -1;
            stickyButton.disabled = !shouldShow || !mainButton || mainButton.disabled;
        }
    },
    // Keep sticky product details and button state aligned with the main purchase panel.
    syncStickyPurchaseBar: function () {
        var stickyBar = document.getElementById("chair-product-sticky-purchase"),
            stickyButton = document.getElementById("chair-product-sticky-add-to-cart"),
            mainButton = document.getElementById("chair-product-add-to-cart"),
            title = document.querySelector(".product_title"),
            subtitle = document.getElementById("chair-product-subtitle"),
            currentPrice = document.getElementById("chair-product-current-price"),
            oldPrice = document.getElementById("b5-collection__old_price"),
            prices = document.getElementById("chair-product-price"),
            reviewSource = document.querySelector(".chair-product-heading__reviews .jdgm-preview-badge"),
            reviewTarget = document.getElementById("chair-product-sticky-review"),
            buttonStateClasses = ["is-active", "is-preorder", "is-adding"];

        if (!stickyBar) return;

        chairUtils.setText(stickyBar.querySelector(".chair-product-sticky-purchase__title"), title ? title.textContent.trim() : "");
        chairUtils.setText(stickyBar.querySelector(".chair-product-sticky-purchase__subtitle"), subtitle ? subtitle.textContent.trim() : "");
        chairUtils.setText(stickyBar.querySelector(".chair-product-sticky-purchase__current-price"), currentPrice ? currentPrice.textContent.trim() : "");
        chairUtils.setText(stickyBar.querySelector(".chair-product-sticky-purchase__old-price"), oldPrice ? oldPrice.textContent.trim() : "");
        stickyBar.classList.toggle("is-on-sale", !!(prices && prices.classList.contains("b5-on-sale-price") && oldPrice && oldPrice.textContent.trim()));

        if (reviewTarget) {
            var reviewClone = reviewSource ? reviewSource.cloneNode(true) : null;
            if (reviewClone) {
                // Keep structured ratings only in the original Judge.me badge.
                reviewClone.querySelectorAll('.jdgm-prev-badge__rich-snippet, [itemprop~="aggregateRating"]').forEach(function (rating) {
                    rating.remove();
                });
            }
            var reviewHTML = reviewClone ? reviewClone.innerHTML.trim() : "";
            reviewTarget.innerHTML = reviewHTML;
            chairUtils.setDisplay(reviewTarget, reviewHTML ? "" : "none");
        }

        if (stickyButton && mainButton) {
            buttonStateClasses.forEach(function (className) {
                stickyButton.classList.toggle(className, mainButton.classList.contains(className));
            });
            stickyButton.setAttribute("aria-label", mainButton.classList.contains("is-preorder") ? "Pre-Order" : "Add to Cart");
        }

        productInter.updateStickyPurchaseBarHeight();
        productInter.updateStickyPurchaseBarVisibility();
    },
    // Initialize scroll, resize, review, and button synchronization for the sticky purchase bar.
    initStickyPurchaseBar: function () {
        var stickyBar = document.getElementById("chair-product-sticky-purchase"),
            stickyButton = document.getElementById("chair-product-sticky-add-to-cart"),
            mainButton = document.getElementById("chair-product-add-to-cart"),
            reviewSource = document.querySelector(".chair-product-heading__reviews .jdgm-preview-badge"),
            ticking = false;

        if (!stickyBar || stickyBar.dataset.stickyReady == "true") return;
        stickyBar.dataset.stickyReady = "true";

        var scheduleVisibilityUpdate = function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                ticking = false;
                productInter.updateStickyPurchaseBarVisibility();
            });
        };

        if (stickyButton && mainButton) {
            stickyButton.addEventListener("click", function (event) {
                event.preventDefault();
                if (!mainButton.disabled) mainButton.click();
            });
        }

        window.addEventListener("scroll", scheduleVisibilityUpdate, { passive: true });
        window.addEventListener("resize", function () {
            productInter.syncStickyPurchaseBar();
            scheduleVisibilityUpdate();
        });

        if (window.MutationObserver) {
            if (reviewSource) {
                new MutationObserver(function () {
                    productInter.syncStickyPurchaseBar();
                }).observe(reviewSource, { childList: true, subtree: true, characterData: true });
            }
            if (mainButton) {
                new MutationObserver(function () {
                    productInter.syncStickyPurchaseBar();
                }).observe(mainButton, { attributes: true, attributeFilter: ["class", "disabled"] });
            }
        }

        if (window.ResizeObserver) {
            new ResizeObserver(function () {
                productInter.updateStickyPurchaseBarHeight();
            }).observe(stickyBar);
        }

        productInter.syncStickyPurchaseBar();
        window.setTimeout(productInter.syncStickyPurchaseBar, 600);
        window.setTimeout(productInter.syncStickyPurchaseBar, 1800);
    },
    // Submit notify-me request for unavailable variants.
    notifyMe: function (target) {
        if (!target || target.classList.contains("disabled")) return;
        var notifymeData = document.getElementById("chair-product-notify-email");
        if (!notifymeData) return;
        if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(notifymeData.value)) {
            alert("Please enter a valid email address.");
            return;
        }
        var requestData = JSON.parse(JSON.stringify(notifymeData.dataset));
        requestData["email"] = notifymeData.value;
        $.ajax({
            type: "POST",
            url: "https://app.boulies.com/notifyorders/notifyme",
            data: requestData,
            // Show notify-me loading state before submit.
            beforeSend: function () {
                target.classList.add("disabled");
                target.textContent = "Sending...";
            },
            // Restore notify-me state if the request fails.
            error: function () {
                alert("We could not submit your notification request. Please try again.");
                target.classList.remove("disabled");
                target.textContent = "Notify me";
            },
            // Confirm notify-me subscription on success.
            success: function () {
                target.textContent = "Request received";
            },
        });
    },
    // Initialize product page interactions.
    init: function () {
        if (!document.querySelector('[data-chair-product-role="variant"]')) {
            chairUtils.setDisabled(document.getElementById("chair-product-add-to-cart"), true);
            chairUtils.setDisplay(document.getElementById("chair-product-cart"), "none");
            return;
        }
        productInter.makeVariantsMap();
        productInter.initProductGalleryVideoInteractions();

        productInter.sortOptionsOnFirstLoad();

        productInter.changeUpholstery(true);

        productInter.setupOptionDropdowns();
        productInter.initPromotionInteractions();
        productInter.initDimensionsLink();
        productInter.setupWarrantyAddonDropdown();
        productInter.initWarrantyAddon();

        var cartBtn = document.getElementById("chair-product-add-to-cart");
        if (cartBtn) {
            cartBtn.addEventListener("click", function (e) {
                e.preventDefault();
                productInter.addToCart(this);
            });
        }
        var cartForm = document.getElementById("chair-product-form");
        if (cartForm) cartForm.addEventListener("submit", function (event) {
            event.preventDefault();
            productInter.addToCart(cartBtn);
        });
        productInter.initStickyPurchaseBar();

        var notifyMeBtn = document.getElementById("chair-product-notify-button");
        if (notifyMeBtn) {
            notifyMeBtn.addEventListener("click", function (e) {
                e.preventDefault();
                productInter.notifyMe(this);
            });
        }

        document.querySelectorAll('[data-chair-product-role="model"]').forEach(function (model) {
            model.addEventListener("change", function () {
                productInter.changeUpholstery();
            });
        });

        document.querySelectorAll('[data-chair-product-role="upholstery"]').forEach(function (upholstery) {
            upholstery.addEventListener("change", function () {
                productInter.changeVariants();
            });
        });

        document.querySelectorAll('[data-chair-product-role="variant"]').forEach(function (option) {
            option.addEventListener("change", function () {
                productInter.changeToThisOption(this);
            });
        });

        document.querySelectorAll('[data-chair-product-role="variant-label"]').forEach(function (option) {
            var colorImage = chairPageData.colorImages[option.dataset.option2 + " / " + option.dataset.option3];
            if (colorImage) {
                option.style.backgroundImage = "url(" + colorImage + ")";
            }
        });

        var initialVariant = document.querySelector('[data-chair-product-role="variant"]:checked');
        var initialUrl = new URL(window.location.href);
        if (initialVariant && initialUrl.searchParams.has("variant") && initialUrl.searchParams.get("variant") != initialVariant.value) {
            initialUrl.searchParams.set("variant", initialVariant.value);
            history.replaceState({}, "", initialUrl);
        }
        window.addEventListener("popstate", function () {
            var variantId = productInter.getUrlParams().variant;
            var selectedVariant = Array.prototype.find.call(document.querySelectorAll('[data-chair-product-role="variant"]'), function (variant) {
                return variant.value == variantId;
            }) || initialVariant;
            if (!selectedVariant) return;
            selectedVariant.checked = true;
            document.querySelectorAll('[data-chair-product-role="model"]').forEach(function (input) {
                input.checked = input.value == selectedVariant.dataset.option1;
            });
            document.querySelectorAll('[data-chair-product-role="upholstery"]').forEach(function (input) {
                input.checked = input.value == selectedVariant.dataset.option2;
            });
            productInter.changeUpholstery(true);
            productInter.refreshOptionDropdowns();
        });

        window.addEventListener("resize", function () {
            productInter.initSaleCodeAutoScroll();
            productInter.scheduleProductGalleryLayout(false);
            productInter.syncProductGalleryVideoMode();
        });
        document.addEventListener("visibilitychange", function () {
            if (document.hidden) {
                clearInterval(productInter.saleCodeScrollTimer);
                clearTimeout(productInter.saleCodeScrollDelay);
                productInter.saleCodeScrollTimer = null;
                productInter.saleCodeScrollDelay = null;
                return;
            }
            productInter.initSaleCodeAutoScroll();
            productInter.scheduleProductGalleryLayout(true);
        });
        window.addEventListener("orientationchange", function () {
            productInter.scheduleProductGalleryLayout(true);
            productInter.syncProductGalleryVideoMode();
        });
        window.addEventListener("pageshow", function () {
            productInter.scheduleProductGalleryLayout(true);
            productInter.syncProductGalleryVideoMode();
        });
    },
};

// ==============================================================
// Run Code After Document Ready
// ==============================================================
// Initialize page scripts after DOM is ready.
$(document).ready(function () {
    collectionGalleryList = $("#chair-product-gallery-track");
    collectionGallery = $("#chair-product-gallery-main");
    productInter.init();
    productInter.initProductGalleryResizeObserver();

    // Open LightGallery from the main product gallery.
    $("#chair-product-gallery-main").on("click", ".pswp_image", function (e) {
        e.preventDefault();
        productInter.openDynamicGallery([{ src: this.href }]);
    });

    // Open LightGallery from dynamic description images.
    $(".dynamic-gallery-item").on("click", function (e) {
        e.preventDefault();
        productInter.openDynamicGallery([{ src: this.href }]);
    });

    // Inject Judge.me reward note when the URL requests it.
    if (productInter.getUrlParams().judgeme_dynamic_form == "1") {
        var injectDOM = document.createElement("div"),
            injectAttempts = 0;
        injectDOM.style.display = "inline-block";
        injectDOM.innerHTML = '<p style=" background-color: #fcfff5; color: #2c662d; margin-top: 10px; padding: 10px 20px; border: 1px solid #a3c293; border-radius: 4px; text-align: left; font-size: 14px; "> <b style=" display: block; margin-bottom: 2px; font-size: 16px; ">Add picture/video for a reward.</b> By submitting with picture/video, boulies will offer 6 months extended warranty as a bonus.</p> <p style=" text-align: left; padding: 4px 20px 0; font-size: 14px; color: #6e6e6e; ">* A notification email will send to you when successfully submit a picture/video review.</p>';
        var insert_notify = setInterval(function () {
            var pictureUploadField = document.querySelector(".jdgm-form-dynamic__picture-upload-field");
            injectAttempts++;
            if (pictureUploadField) {
                pictureUploadField.appendChild(injectDOM);
                clearInterval(insert_notify);
            } else if (injectAttempts >= 30) {
                clearInterval(insert_notify);
            }
        }, 1000);
    }

    // Initialize best-of award carousel when present.
    if (document.querySelector('[data-chair-product-role="best-of"]')) {
        $('[data-chair-product-role="best-of-list"]').slick({
            slidesToShow: 3,
            dots: false,
            arrows: false,
            speed: 500,
            responsive: [
                {
                    breakpoint: 801,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    },
                },
            ],
        });
    }
});
